import type {
  ChoiceKey,
  NupChoiceResponse,
  NupEnrollResponse,
  NupStatusResponse,
} from '@ark/nup-shared';
import { activityConfig } from '@ark/nup-shared';
import {
  BaseApiClient,
  Retry,
  isApiServerError,
  exponentialBackoff,
} from '@ark/web-api/frontend';

class NupApiClient extends BaseApiClient {
  constructor() {
    super({
      apiPrefix: activityConfig.apiPrefix,
    });
  }

  @Retry({
    when: isApiServerError,
    maxAttempts: 3,
    delay: exponentialBackoff(1000, 5000),
  })
  async getStatus(): Promise<NupStatusResponse> {
    return await this.get<NupStatusResponse>('status');
  }

  async enroll(): Promise<NupEnrollResponse> {
    return await this.post<NupEnrollResponse>('enroll');
  }

  async updateChoice(choiceKey: ChoiceKey): Promise<NupChoiceResponse> {
    return await this.post<NupChoiceResponse>('choice', { choiceKey });
  }
}

export const apiClient = new NupApiClient();
